// extracted by mini-css-extract-plugin
export default {"mainWrapper":"CategorySelector_mainWrapper__bkAs8"};